import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}));

/* Types */
export const GET_POSTALS = 'GET_POSTALS'

export const GET_ADDRESS = 'GET_ADDRESS'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_POSTALS:
			return state.set('Search', new Immutable.List(action.Obj));
		case GET_ADDRESS:
			return state.set('Get', new Immutable.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

export const postalCodes = () => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/postalCodes',
			method: "POST",
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_POSTALS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getAddress = (form, formName = "") => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getAddress',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			const data = response.data

			let estado = []
			estado.push({id: data.estados.id, valor: data.estados.estado})
			let municipio = []
			municipio.push({id: data.municipioDelegacion.id, valor: data.municipioDelegacion.municipioDelegacion})
			let ciudad = []
			ciudad.push({id: data.ciudad.id, valor: data.ciudad.ciudad})

			let obj = {
				identificador: Utils.getUUID(),
				estado: estado,
				municipio: municipio,
				ciudad: ciudad,
				colonia: data.colonias,
				state: data.estados.id,
				town: data.municipioDelegacion.id,
				city: data.ciudad.id,
				colony: data.colonias.length === 1 ? data.colonias[0].id : undefined,
				formName
			}

			dispatch({type: GET_ADDRESS, Obj: obj})
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}


// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Postal.js